<template>
  <div class="miSeleccion">

    <div v-if="loading">
      <div class="col-md-12 center">
        <div class="loading"><img src="@/assets/img/loading.gif" alt=""></div>
      </div>
    </div>

    <table v-else class="table table-hover"> 
      <thead> 
        <tr> 
          <th width=" 5%" @click="sortBy('tipo')"><i class="fa fa-sort"></i></th>
          <th width=" 3%" class="center">#</th> 
          <th width="30%" @click="sortBy('titulo')">{{ $t('Artículo') }} <i class="fa fa-sort"></i></th> 
          <th width="20%" @click="sortBy('autor')">{{ $t('Autor') }} <i class="fa fa-sort"></i></th> 
          <th width="10%" @click="sortBy('formato')">{{ $t('Formato') }} <i class="fa fa-sort"></i></th> 
          <th width=" 7%" @click="sortBy('precio')" class="align-right">{{ $t('Precio') }} <i class="fa fa-sort"></i></th> 
          <th width=" 9%" @click="sortBy('cantidad')" class="align-right">{{ $t('Cantidad') }} <i class="fa fa-sort"></i></th> 
          <th width=" 8%" @click="sortBy('importe')" class="align-right">{{ $t('Importe') }} <i class="fa fa-sort"></i></th> 
        </tr> 
      </thead> 
      <tfoot>
        <tr class="selected-data">
          <td></td>
          <td class="center"><!-- {{ ArticulosMarcados }} --></td>
          <td colspan="4" class="align-right">TOTAL</td>
          <td class="align-right">{{ CantidadArticulos }}</td>
          <td class="align-right">{{ toCurrency(ImporteTotal) }}</td>
        </tr>
        <tr>
          <td></td>
          <td colspan="4" class="align-right">
            <template v-if=" getUserRole == 'admin' ">
              <div class="buscador-avanzado-csd mt17 mr20 display-inline-block" >
                <div class="input-group" >
                  <div class="input-group-addon"><span>Contenedor</span></div>
                  <select class="form-control capitalize" v-model="contenedorId">
                    <option></option>
                    <template v-for=" (item, index) in contenedores ">
                      <option :value=" item.ID " :class=" item.TYPE + '-color capitalize' " :key="index">
                        {{ item.TYPE }} - {{ item.NOMBRE_ES }}
                      </option>
                    </template> 
                  </select>
                </div>
              </div>
              <div class="display-inline-block float-right mt20">
                <button class="btn buy-link todo" @click="updateContenedor">Actualizar contenedor</button>
              </div>
            </template>
          </td>
          <td></td>
          <td colspan="3" class="align-right buy-type">
            <button v-if=" sendingOrder == null " class="btn buy-link todo mt20"><img src="@/assets/img/loading-mini-white.gif"></button>         
            <button v-if=" sendingOrder == false && MiPedido.length > 0 " class="btn buy-link todo mt20"
              @click="sendOrder">{{ $t('Confirmar y enviar pedido') }}
            </button>

          </td>
        </tr>
      </tfoot>
      <tbody> 
        <tr v-for=" (item, index) in filteredData " :key="index"> 
          <td class="padding0"><span :class="'box uc '+item.tipo">{{ item.tipo.substring(0,1) }}</span></td>
          <th scope="row" class="center">{{ index + 1 }}</th> 
          <td>{{ item.titulo }}</td> 
          <td>{{ item.autor }}</td> 
          <td class="uc">{{ item.formato }}</td> 
          <td class="align-right">{{ toCurrency(item.precio) }}</td>
          <td class="align-right">{{ item.cantidad }}</td>
          <td class="align-right">
            <div v-if=" item.importe == null "><img src="@/assets/img/loading-mini.gif" ></div>
            <template v-else>{{ toCurrency(item.importe) }} </template>
          </td>
        </tr> 
      </tbody> 
    </table>

    <template v-if="success">
      <div class="frm-success">{{ success_message }}</div>
      <br>
      <div class="save-order center">
        <a :href="getApiUrl + getLocale + '/' + links.imprimir" class="buy-link todo" target="_blank"><i class="fa fa-print"></i>{{ $t('Imprimir') }}</a>
        <a :href="getApiUrl + getLocale + '/' + links.pdf" class="buy-link todo" target="_blank"><i class="fa fa-file-pdf-o"></i>{{ $t('Guardar') }} PDF</a>
        <a :href="getApiUrl + getLocale + '/' + links.excel" class="buy-link todo" target="_blank"><i class="fa fa-file-excel-o"></i>{{ $t('Guardar') }} EXCEL</a>
        <a :href="getApiUrl + getLocale + '/' + links.email" class="buy-link todo" target="_blank"><i class="fa fa-envelope-o"></i>{{ $t('Enviar por') }} email</a>
      </div>
      <br><br><br>
      <div class="center">
        <router-link :to="{ name: 'seleccion' }" class="buy-link todo">{{ $t('Volver a mi selección') }}</router-link>
      </div>
    </template>
  </div>
</template>

<i18n>
{
  "es": {
    "Artículo": "Artículo",
    "Autor": "Autor",
    "Formato": "Formato",
    "Precio": "Precio",
    "Cantidad": "Cantidad",
    "Importe": "Importe",
    "Comprar": "Comprar",
    "Confirmar y enviar pedido": "Confirmar y enviar pedido",
    "Imprimir": "Imprimir",
    "Guardar": "Guardar",
    "Enviar por": "Enviar por",
    "Volver a mi selección": "Volver a mi selección",
    "Enviar email": "Enviar email"
  },
  "en": {
  },
  "ca": {
    "Artículo": "Article",
    "Autor": "Autor",
    "Formato": "Format",
    "Precio": "Preu",
    "Cantidad": "Quantitat",
    "Importe": "Import",
    "Comprar": "Comprar",
    "Confirmar y enviar pedido": "Confirmar i enviar comanda",
    "Imprimir": "Imprimir",
    "Guardar": "Guardar",
    "Enviar por": "Enviar per",
    "Volver a mi selección": "Tornar a Seleccionats",
    "Enviar email": "Enviar email"
  }
}
</i18n>

<script>
  import axios from 'axios';
  import { mapGetters, mapMutations } from 'vuex';

	export default {
    props: ['tipo'],
    data: () => {
      return {
        //MiCompra: [],
        sortKey: '',
        sortOrders: { tipo: 1, titulo: 1, autor: 1, formato: 1, precio: 1, cantidad: 1, importe: 1 },
        rawData: [],
        loading: false,
        sendingOrder: false,
        success: false,
        success_message: "",
        links: [],
        contenedores: [],
        contenedorId: '',
      }
    },
    created() {
      this.setPasoCompra(2);
      this.getMiCompra();
      if( this.getUserRole == 'admin' ){
        this.getContenedores();
      }
    },
    mounted(){ },
    computed: { 
      ...mapGetters(['getLocale', 'getApiUrl', 'getMiPedidoTipo', 'getUserRole']),
      MiPedido: function(){ return (this.rawData != '') ? this.rawData.data.data : ''; },
      CantidadArticulos: function(){
        if( this.MiPedido ){
          return (this.MiPedido.filter( (articulo) => articulo.cantidad > 0)).reduce(
            (total, articulo) => total + parseInt(articulo.cantidad), 0);
        }else{ return 0 }
      },
      ImporteTotal: function(){
        if( this.MiPedido ){
          return (this.MiPedido.filter( (articulo) => articulo.cantidad > 0)).reduce(
            (total, articulo) => total + (articulo.precio * articulo.cantidad), 0);
        }else{ return 0 }
      },
      filteredData: function () {
        var sortKey = this.sortKey
        var order = this.sortOrders[sortKey] || 1
        var data = this.MiPedido
        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      }
    },
    methods:{
      ...mapMutations(['setPasoCompra']),
      getMiCompra(){
        this.showLoading();

        // REQUEST WITH TIPO !!!
        let url = (this.getMiPedidoTipo == 'todo') ? (this.getApiUrl + this.getLocale + '/mipedido') : (this.getApiUrl + this.getLocale + '/mipedido/' + this.getMiPedidoTipo);

        axios.get(url)
          .then( (respuesta) => {
            //console.log(respuesta);
            this.rawData = respuesta;
            this.hideLoading();
          })
          .catch( (error) =>{ 
            this.error_message = error.response.data.status + ' ' + error.response.data.msg;
            this.error = true;
            this.hideLoading();
          });     
      },
      sendOrder(){
        this.sendingOrder = null;

        let url = (this.getMiPedidoTipo == 'todo') ? (this.getApiUrl + this.getLocale + '/mipedido') : (this.getApiUrl + this.getLocale + '/mipedido');

        axios.put(url,
          this.MiPedido
        )
          .then( (respuesta) => {
            setTimeout(()=>{
              this.setPasoCompra(3);
              this.success_message = respuesta.data.msg;
              //console.log(respuesta)
              this.links = respuesta.data.data;
              this.sendingOrder = true;
              this.success = true;

            }, 1000);
          })
          .catch( (error) =>{ 
            alert(error.response.data.status + ' ' + error.response.data.msg);
            this.sendingOrder = false;
          }); 

      },
      getContenedores(){
        axios.get( this.getApiUrl + this.getLocale + '/contenedor/lista')
          .then( (respuesta) => {
            this.contenedores = respuesta.data.data;
          })
          .catch( (error) =>{ 
            alert(error.response.data.status + ' ' + error.response.data.msg);
          }); 
      },
      updateContenedor(){
        if( this.contenedorId > 0 ){
        axios.put( this.getApiUrl + this.getLocale + '/contenedor/estatico/' + this.contenedorId,
          this.MiPedido 
        )
          .then( (respuesta) => {
            alert(respuesta.data.msg);
          })
          .catch( (error) =>{ 
            alert(error.response.data.status + ' ' + error.response.data.msg);
          });
        }else{
          alert('Tienes que seleccionar un contendor!');
        }
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
      sortBy(key){
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
      },     
    },
    watch:{
    
    }
  }
</script>
